import {
  BECOME_USER_DELEGATE_SUCCESS,
  FETCH_USER_DONE,
  FETCH_USER_ERROR,
  FETCH_USER_LOADING,
  FETCH_USER_SUCCESS,
  TRANSFER_OWNER_SUCCESS,
  UPDATE_ACCOUNT_NAME_SUCCESS,
  UPDATE_AUTHENTICATION_METHOD_SUCCESS,
  UPDATE_CONFIGURATION_DEFAULTS_SUCCESS
} from '../actions/actionTypes';
import initialState from './initialState';

// handles User related actions

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        error: null
      };
    case FETCH_USER_ERROR:
      return {
        ...state,
        user: null,
        error: action.error
      };
    case FETCH_USER_DONE:
      return {
        ...state,
        loading: false
      };
    case UPDATE_AUTHENTICATION_METHOD_SUCCESS:
    case UPDATE_CONFIGURATION_DEFAULTS_SUCCESS:
    case UPDATE_ACCOUNT_NAME_SUCCESS:
    case TRANSFER_OWNER_SUCCESS:
      // How do I get the current user from the state and then modify it?
      // Should I be doing this here?
      const user = state.user;
      user.tenant = action.tenant;
      return {
        ...state,
        user
      };
    case BECOME_USER_DELEGATE_SUCCESS:
      // When the user becomes a delegate, server returns a new user object
      return {
        ...state,
        user: action.user,
        error: null
      };
    default:
      return state;
  }
};
